<div class="container page page-register">

  <div class="page-header">
    <h1 class="page-title">
      {{'Register' | translate}}
    </h1>
  </div>

  <div class="page-body">

    <div class="login-wrapper">

      <div class="form">
        <label>{{'Select account type' | translate}}</label>
        <select class="form-control" [(ngModel)]="formData.accountType">
          <option *ngFor="let type of accountTypes" [value]="type['value']">
            {{type['label'] | translate}}
          </option>
        </select>
      </div>

      <div class="btn-toolbar mt-4 justify-content-end">
        <button class="btn btn-primary" (click)="Next()">
          {{'Next' | translate}}
        </button>
      </div>

    </div>

  </div>

</div>
